import { useMemo } from "react";
import { prepareThumbnailUrl } from "~/utils/utils";
import { useFileTokenContext } from "../FilePreview";

export const usePrepareFileUrl = (url, width, height, scale) => {
  const tokens = useFileTokenContext();

  const thumbnail = useMemo(() => {
    return prepareThumbnailUrl(url, width, height, scale, tokens?.thumb_token, tokens?.download_token);
  }, [url, width, height, scale, tokens?.thumb_token, tokens?.download_token]);

  return thumbnail;
};
